import { useCallback, useEffect, useMemo, useState } from 'react';

import { startCase } from 'lodash';

import { useGlobalStore } from '@Stores/global';

import { useSnippetStore } from '../store';

const RULE_GROUP = 'Page'
const RULE_TYPE = 'cms-page'

const CONTENT_TYPES = ['offer', 'feature', 'program', 'banner', 'card', 'case', 'state']
const TEMPLATES = ['finish', 'index', 'plain', 'rules', 'dynamic']

export default function useExtraFields() {
  const { siteSettings: { useThemeConfig } } = useGlobalStore()
  const { templates: { getTemplates } } = useSnippetStore()

  const [templates, setTemplates] = useState([])
  const types = useThemeConfig('types')

  const content = useMemo(() => {
    if (types) {
      return Object.keys(types).filter(type => !CONTENT_TYPES.includes(type))
    }
    return []
  }, [types])

  const fetchTemplates = useCallback(async type => {
    const { options } = await getTemplates('', [])(type)
    const templates = [{ value: type, label: `${startCase(type)} / Default` }]

    for (const { value } of options) {
      if (TEMPLATES.includes(value)) {
        continue;
      }

      templates.push({
        value: `${type}-${value}`,
        label: `${startCase(type)} / ${startCase(value)}`,
      })
    }

    return templates
  }, [getTemplates])

  useEffect(() => {
    Promise
      .all(content.map(type => fetchTemplates(type)))
      .then(options => setTemplates(options.flat()))
  }, [content, fetchTemplates])

  return useMemo(() => [
    {
      value: 'cmsContentType',
      label: 'Content Type',
      group: RULE_GROUP,
      type: RULE_TYPE,
      options: content.map(type => ({ value: type, label: startCase(type) })),
    },
    {
      value: 'cmsTemplate',
      label: 'Template',
      group: RULE_GROUP,
      type: RULE_TYPE,
      options: templates,
    },
  ], [content, templates])
}
